import { network } from 'services/network';

export const customerSet = (params) => {
    return network.post(`api/bo/customer/set`, params).then((response) => response.data);
};
